module.exports = __webpack_public_path__ + "static/img/Team_spirit5.787ef8f.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/Team_spirit5.png
// module id = Gdi9
// module chunks = 0